module.exports = __webpack_public_path__ + "static/pic04-fa2e4cdb3ddba100b197f0fbcac84462.jpg";